import { Dialog, Transition } from "@headlessui/react";
import useLoading from "../../hooks/useLoading";
import useToast from "../../hooks/useToast";
import { Fragment, useEffect, useRef, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import useAuth from "../../hooks/useAuth";
import { ArrowPathIcon, PaperAirplaneIcon } from "@heroicons/react/24/solid";
import { isEmpty } from "lodash";
import { recoveryRequest } from "../../services/ api_services";
import { ToastTypes } from "../../context/ToastProvider";

export default function RecoveryCouponDialog({ isOpen, onClose, gridRow }) {
  const { auth } = useAuth();
  const { showToast } = useToast();
  const { loading, setLoading } = useLoading();

  const [couponCnt, setCouponCnt] = useState(0);

  const inputRefRecoveryCount = useRef();

  useEffect(() => {
    if (isOpen) {
      if (inputRefRecoveryCount && inputRefRecoveryCount.current) {
        inputRefRecoveryCount.current.focus();
      }
    }
  }, [isOpen]);

  useEffect(() => {
    console.log("GRID ROW ==> ", gridRow);
  }, [gridRow]);

  const onClear = () => {
    setCouponCnt(0);
  };

  const handleOnClose = () => {
    onClear();
    onClose();
  };

  const handleOnChangeCouponCount = (e) => {
    const rawValue = e.target.value.replace(/\D/g, "");
    if (rawValue.length <= 7) {
      setCouponCnt(rawValue && !isEmpty(rawValue) ? parseInt(rawValue, 10) : 0);
    }
  };

  const sendRecoveryCouponRequest = async () => {
    console.log("auth admin_seq => ", auth.admin_seq);
    console.log("auth admin_name => ", auth.admin_name);
    console.log("gridRow admin_seq => ", gridRow.admin_info.admin_seq);
    console.log("gridRow admin_nm => ", gridRow.admin_info.admin_nm);
    if (couponCnt <= 0) {
      alert("회원권 회수 수량을 입력해 주세요.");
      return;
    } else {
      // eslint-disable-next-line no-restricted-globals
      const confirmRecovery = confirm(
        gridRow.admin_info.admin_nm +
          "(" +
          gridRow.admin_level_nm +
          ")" +
          "에게서 " +
          couponCnt +
          "개 회원권을 회수하시겠습니까?"
      );
      if (confirmRecovery) {
        console.log("SENT REQ ==> ");

        try {
          setLoading(true);
          const requestData = {
            source_user: auth.admin_seq,
            target_user: gridRow.admin_info.admin_seq,
            coupon_cnt: parseInt(couponCnt),
            source_dt: null,
            target_dt: null,
          };
          const response = await recoveryRequest(requestData);
          console.log("🚀 ~ sendRecoveryCouponRequest ~ response:", response);
          setLoading(false);
          if (response && response.status === 200) {
            if (response.data) {
              //회수수량이 잔여 수량보다 많으면
              if (response.data.resultCode === 400) {
                // showToast(ToastTypes.WARNING, "경고", response.data.message ?? "");
                alert(response.data.message ?? "");
                if (inputRefRecoveryCount && inputRefRecoveryCount.current) {
                  inputRefRecoveryCount.current.focus();
                }
                return;
              } else if (response.data.resultCode === 200) {
                alert("회수 요청을 성공했습니다.");
                onClear();
                onClose();
              }
            } else {
              alert(
                "회수 요청했을 떄 오류가 생겼습니다.관리자에게 문의하십시오!"
              );
              return;
            }
          } else {
            alert(
              "회수 요청했을 떄 오류가 생겼습니다.관리자에게 문의하십시오!"
            );
            return;
          }
        } catch (e) {
          setLoading(false);
          console.log("Error complicated confirmRecovery : ", e);
        }
      } else {
        console.log("CANCELLED ==> ");
      }
    }
  };

  const formattedCount = new Intl.NumberFormat().format(couponCnt);

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => handleOnClose()}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    onClick={() => {
                      handleOnClose();
                    }}
                  >
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="font-normal text-gray-900 text-sm"
                    >
                      회원권 회수 안내
                    </Dialog.Title>
                  </div>
                </div>

                <div className="justify-center py-5  sm:py-5 rounded flex-col sm:flex-col space-y-2 sm:space-y-2 ">
                  <div className="w-full rounded  border-gray-300 border px-3 py-3 sm:col-span-2 justify-start">
                    <label className="block text-base font-semibold leading-6 text-blue-700">
                      발송인
                    </label>
                    <ul className="inline-flex w-full mt-2 columns-2 items-center">
                      <li className="w-1/5">
                        <label
                          htmlFor="source-user"
                          className="block w-30 text-sm font-medium text-gray-700"
                        >
                          발송인
                        </label>
                      </li>
                      <li className="w-3/5">
                        <input
                          type="text"
                          name="source_user"
                          id="source_user"
                          disabled
                          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                          value={auth.admin_name}
                        />
                      </li>
                    </ul>
                    <ul className="inline-flex w-full mt-1 columns-2 items-center">
                      <li className="w-1/5">
                        <label
                          htmlFor="source-user"
                          className="block w-30 text-sm font-medium text-gray-700"
                        >
                          직급
                        </label>
                      </li>
                      <li className="w-3/5">
                        <input
                          type="text"
                          name="source_user"
                          id="source_user"
                          disabled
                          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                          value={auth.admin_level_nm}
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="w-full rounded border-gray-300 border px-3 py-3 sm:col-span-2 justify-start">
                    <label className="block text-base font-semibold leading-6 text-blue-700">
                      수송인
                    </label>
                    <ul className="inline-flex w-full mt-2 columns-2 items-center">
                      <li className="w-1/5">
                        <label
                          htmlFor="source-user"
                          className="block w-30 text-sm font-medium text-gray-700"
                        >
                          수송인
                        </label>
                      </li>
                      <li className="w-3/5">
                        <input
                          type="text"
                          name="source_user"
                          id="source_user"
                          disabled
                          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                          value={
                            (gridRow &&
                              gridRow.admin_info &&
                              gridRow.admin_info.admin_nm) ??
                            ""
                          }
                        />
                      </li>
                    </ul>
                    <ul className="inline-flex w-full mt-1 columns-2 items-center">
                      <li className="w-1/5">
                        <label
                          htmlFor="source-user"
                          className="block w-30 text-sm font-medium text-gray-700"
                        >
                          직급
                        </label>
                      </li>
                      <li className="w-3/5">
                        <input
                          type="text"
                          name="source_user"
                          id="source_user"
                          disabled
                          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                          value={(gridRow && gridRow.admin_level_nm) ?? ""}
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="w-full rounded shadow border-gray-300 border px-3 py-3 sm:col-span-2 justify-start">
                    <label className="block text-base font-semibold leading-6 text-blue-700">
                      회수 수량
                    </label>
                    <ul className="inline-flex w-full mt-2 columns-2 items-center">
                      <li className="w-1/5">
                        <label
                          htmlFor="source-user"
                          className="block w-30 text-sm font-medium text-gray-700"
                        >
                          회수 수량
                        </label>
                      </li>
                      <li className="w-3/5">
                        <input
                          ref={inputRefRecoveryCount}
                          type="text"
                          placeholder="수량을 입력해 주세요"
                          className="block w-full text-sm rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600 focus:ring-blue-600 sm:leading-6"
                          min={"0"}
                          value={formattedCount}
                          onChange={(e) => handleOnChangeCouponCount(e)}
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="flex justify-center">
                    <button
                      type="button"
                      className="inline-flex items-center gap-x-2 mt-3 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 caret-transparent"
                      onClick={() => {
                        sendRecoveryCouponRequest();
                      }}
                    >
                      <ArrowPathIcon
                        className="-ml-0.5 h-5 w-5"
                        aria-hidden="true"
                      />
                      회수하기
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
